import SigningInSpinner from './SigningInSpinner'

export default SigningInSpinner
